var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPipedriveExport = function SvgPipedriveExport(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.pipedriveStyle0{fill-rule:evenodd;clip-rule:evenodd;fill:#26292C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pipedrive_letter_logo_light"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pipedrive_monogram_logo_light",
    transform: "translate(67.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "pipedriveStyle0 disabledStyle",
    d: "M-27.6-4.8c0,8.3,4.2,17.3,13.5,17.3c6.9,0,13.9-5.4,13.9-17.5c0-10.6-5.5-17.7-13.7-17.7 C-20.4-22.6-27.6-17.9-27.6-4.8z M-10.5-38C6.2-38,17.4-24.8,17.4-5.1c0,19.4-11.8,32.9-28.7,32.9c-8.1,0-13.2-3.5-15.9-5.9 c0,0.6,0,1.3,0,2v26.3h-17.3v-70c0-1-0.3-1.3-1.3-1.3h-5.9v-15.3h14.5c6.7,0,8.4,3.4,8.7,6C-25.8-33.6-20.2-38-10.5-38z"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPipedriveExport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pipedrive_export.7460d85f.svg";
export { ForwardRef as ReactComponent };